import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_ACTIONS_MENU_OPENED_LOCATIONS = ['composer_button', 'zero_state_chip'] as const;

export type WorkspaceAgentActionsMenuOpenedLocation = (typeof WORKSPACE_AGENT_ACTIONS_MENU_OPENED_LOCATIONS)[number];

const META: Meta = {
  description: 'The workspace agent composer Actions menu opens',
  name: 'agent_actions_menu_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Whether the menu was opened from the composer Actions button or the zero-state chip',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_ACTIONS_MENU_OPENED_LOCATIONS],
    },
  ],
};

export default META;
